import React from 'react';
import { LandingContentProvider } from '../context/LandingContentContext';
import Navigation from '../components/shop/Navigation';
import Hero from '../components/shop/Hero';
import Configurator from '../components/shop/Configurator';
import ImageShowcase from '../components/shop/ImageShowcase';
import HotspotShowcase from '../components/shop/HotspotShowcase';
import Categories from '../components/shop/Categories';
import BrandMarquee from '../components/shop/BrandMarquee';
import ServicesPromo from '../components/shop/ServicesPromo';
import Footer from '../components/shop/Footer';
import WhatsAppButton from '../components/shop/WhatsAppButton';
import CookieConsent from '../components/shop/CookieConsent';
import PromoBannerSlider from '../components/shop/PromoBannerSlider';
import SwissCustomerNote from '../components/shop/SwissCustomerNote';
import '../styles/shop.css';

export default function ShopLanding() {
  return (
    <LandingContentProvider>
      <div data-testid="shop-landing" style={{ background: 'var(--bg-default)', minHeight: '100vh' }}>
        <div className="noise-overlay" />
        <Navigation />
        <Hero />
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px' }}>
          <PromoBannerSlider />
        </div>
        <Configurator />
        <ImageShowcase />
        <HotspotShowcase />
        <Categories />
        <BrandMarquee />
        <ServicesPromo />
        <SwissCustomerNote />
        <Footer />
        <WhatsAppButton />
        <CookieConsent />
      </div>
    </LandingContentProvider>
  );
}
